<template>

    <el-row id="dictionDevelop" style="height: 100%">


        <el-col :span="8" style="height:auto;background: white;width: 400px">
            <el-row type="flex" justify="center" style="height: auto">
                <el-col :span="24">
                    <el-col :span="24" style="text-align: end;">
                        <span  style="font-size: 19px;float: left;line-height: 30px;font-weight: bold">数据字典列表</span>
                        <el-button type="success" style="background: #4EC880" icon="el-icon-plus" size="small"
                                   @click="open3">新增字典
                        </el-button>
                    </el-col>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" id="search" style="height: calc(100% - 43px)">
                <el-col :span="24" style="border: 1px solid #eee;height: auto">
                    <div style="padding: 10px">
                        <el-input
                                class="sWei"
                                placeholder="请输入数据字典名称进行快速检索"
                                v-model="filterText">
                        </el-input>
                    </div>
                    <!--:class="$style.scrollbar"-->

                        <el-tree
                                class="filter-tree"
                                :data="data"
                                @node-click="handleNodeClick"
                                :props="defaultProps"
                                node-key="define_id"
                                :highlight-current="true"
                                :filter-node-method="filterNode"
                                :default-expanded-keys="[1000,2000]"
                                ref="tree">
                        </el-tree>

                </el-col>
            </el-row>
        </el-col>
        <el-col :span="16" class="StoCen" style="height: auto">
            <el-row style="height: 20px;margin-top: 4px" type="flex" align="middle">
                <el-col :span="3" style="font-size: 17px;font-weight: bold">数据字典</el-col>
                <el-col :span="14" style="color: #409EFF;font-size: 17px;font-weight: bold">{{schTitle1}}</el-col>
                <el-col :span="3" :push="4">
                    <el-button type="text" @click="open4"
                               :style="{color: updataActive?'#FF9901':'#eee',float:'right'}"
                               style="font-size: 17px;font-weight: bold" id="el-button">编辑定义
                    </el-button>
                </el-col>

            </el-row>
            <el-row class="xux"></el-row>
<!--                        <el-row v-for="(item,index) in valueArr" :key="index" style="font-size: 12px;height: auto">-->
<!--                        说明{{index+1}}:{{item}}-->
<!--                    </el-row>-->
            <el-row type="flex" align="middle">
                <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px ">选项总数：{{tableData.length}}个</el-col>
                <el-col :span="8" style="text-align: end;">
                    <el-button type="success" style="background: #4EC880;border: none" icon="el-icon-plus" size="small"
                               @click="addListOpen"
                               :disabled="openOff">添加选项</el-button>
                </el-col>
            </el-row>
            <el-col>
                <el-table :data="tableData" stripe style="width: 100%" border @row-click="myRowClick" :header-cell-style="{'color':'black'}">
                    <el-table-column prop="key" label="键值" sortable class="Tnumber" fixed="left" width="200"></el-table-column>
                    <el-table-column prop="value1" :label="valueArr[0]" width="200" sortable v-if="0<valueArr.length"></el-table-column>
                    <el-table-column prop="value2" :label="valueArr[1]" width="200" sortable v-if="1<valueArr.length"></el-table-column>
                    <el-table-column prop="value3" :label="valueArr[2]" width="200" sortable v-if="2<valueArr.length"></el-table-column>
                    <el-table-column prop="value4" :label="valueArr[3]" width="200" sortable v-if="3<valueArr.length"></el-table-column>
                    <el-table-column prop="value5" :label="valueArr[4]" width="200" sortable v-if="4<valueArr.length"></el-table-column>
                    <el-table-column prop="value6" :label="valueArr[5]" width="200" sortable v-if="5<valueArr.length"></el-table-column>
                    <el-table-column prop="value7" :label="valueArr[6]" width="200" sortable v-if="6<valueArr.length"></el-table-column>
                    <el-table-column prop="value8" :label="valueArr[7]" width="200" sortable v-if="7<valueArr.length"></el-table-column>
                    <el-table-column prop="status" label="状态"  sortable></el-table-column>
                    <el-table-column label="操作" label-class-name="dictionDevelop_table_cell" fixed="right" width="80">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click="myDetails(scope.$index, scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-col>

        <!--新增字典-->
        <el-dialog title="" :visible.sync="dialogFormVisible">
            <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                <span style="color: #3998F7;font-size: 22px">新增字典</span>
                <span>
                <el-button @click="submitForm" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="abolish(dialogFormVisible,form)" size="small">取消</el-button>
                </span>
            </div>
            <el-form :model="form" :rules="rules" ref="ruleForm" class="demo-ruleForm"
                     style="margin-left:80px" hide-required-asterisk>
                <!-- <el-form-item label="名称" label-width="120px">
                     <el-input v-model="form.name"></el-input>
                 </el-form-item>
                 <el-form-item label="类型" label-width="120px">
                     <el-input v-model="form.category"></el-input>
                 </el-form-item>-->
                <el-form-item v-if="key !== 'status'" :label="judge(key)" label-width="90px" v-for="(item,key) in form" :key="key"
                               :prop="key" :class="[key=='parent_category'?'':'dictionDevelop_star']">
                    <el-select v-if="key == 'parent_category'" v-model="form[key]" :placeholder="judgePlace(key)" style="width: 100%" >
                        <el-option
                                v-for="item in parentCategoryArray"
                                :key="item.category"
                                :label="item.name"
                                :value="item.category">
                        </el-option>
                    </el-select>
<!--                    <el-select v-if="key == 'parent_key'" v-model="form[key]" :placeholder="judgePlace(key)" style="width: 100%">-->
<!--                        <el-option-->
<!--                                v-for="item in parentCategoryKey"-->
<!--                                :key="item.id"-->
<!--                                :label="item.value"-->
<!--                                :value="item.id">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
                    <el-input v-else :type=" judgeType(key)" :placeholder="judgePlace(key)" v-model="form[key]"
                              :maxlength="200"></el-input>

                </el-form-item>
                <el-form-item label="有效" label-width="90px">
                    <el-switch
                            v-model="form.status"
                            active-color="#13ce66">
                    </el-switch>
                </el-form-item>

                <el-button type="success" icon="el-icon-plus" size="mini" @click="addExplain(form)"
                           style="margin-left: 85%;background: #4EC880">添加字段名</el-button>
            </el-form>
        </el-dialog>

        <!--编辑字典-->
        <el-dialog title="" :visible.sync="dialogFormVisible2">
            <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                <span style="color: #3998F7;font-size: 22px">编辑字典定义</span>
                <span>
                <el-button @click="submitForm2" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="abolish(dialogFormVisible2,upForm,len)" size="small">取消</el-button>
                </span>

            </div>
            <el-form :model="upForm" :rules="rules2" ref="ruleForm2" style="margin-left:80px" class="demo-ruleForm" hide-required-asterisk>
                <el-form-item v-if="key !== 'status'" :label="judge(key)" label-width="90px" v-for="(item,key) in upForm"  :key="key"
                               :prop="key" :class="[key=='parent_category'?'':'dictionDevelop_star']">
                    <el-select v-if="key == 'parent_category'" v-model="upForm[key]" :placeholder="judgePlace(key)" style="width: 100%" :disabled="disableInp" >
                        <el-option
                                v-for="item in parentDicArray"
                                :key="item.category"
                                :label="item.name"
                                :value="item.category">
                        </el-option>
                    </el-select>
<!--                    <el-select v-if="key == 'parent_key'" v-model="upForm[key]" :placeholder="judgePlace(key)" style="width: 100%" :disabled="disableInp">-->
<!--                        <el-option-->
<!--                                v-for="item in parentCategoryKey"-->
<!--                                :key="item.id"-->
<!--                                :label="item.value"-->
<!--                                :value="item.id">-->
<!--                        </el-option>-->
<!--                    </el-select>-->

                    <el-input v-else :type=" judgeType(key)" v-model="upForm[key]" :maxlength="200" :disabled="key=='category'"></el-input>

                </el-form-item>
                <el-form-item label="有效" label-width="90px">
                    <el-switch
                            v-model="upForm.status"
                            active-color="#13ce66">
                    </el-switch>
                </el-form-item>
                <el-button type="success" icon="el-icon-plus" size="mini" @click="addExplain(upForm)"
                           style="margin-left: 85%;background: #4EC880" >添加字段名</el-button>
            </el-form>
        </el-dialog>

        <!--添加选项-->
        <el-dialog title="" :visible.sync="dialogFormVisible3">
            <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                <span style="color: #3998F7;font-size: 22px">添加字典选项</span>
                <span>
                <el-button @click="submitForm3" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="abolish2(dialogFormVisible3,addListForm.value)" size="small">取消</el-button>
                </span>

            </div>
            <el-form :model="addListForm" :rules="rules3" ref="ruleForm3" class="demo-ruleForm"
                     style="margin-left:80px" hide-required-asterisk>
                <el-form-item label="键值" label-width="90px" prop="key" class="dictionDevelop_star">
                    <el-input v-model="addListForm.key" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="上级键值" label-width="90px">
                    <el-select  v-model="addListForm.parent_key" placeholder="请选择" :disabled="haveParent" style="width: 100%" >
                        <el-option
                                v-for="item in parentDicValue1"
                                :key="item.id"
                                :label="item.value"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="显示标题" label-width="90px" >
                    <el-input v-model="addListForm.title" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item :label="judge(key,true)" label-width="90px" v-for="(item,key) in addListForm.value"
                              :key="key" v-if="onOff(key)<valueArr.length" prop="item">

<!--                    <el-select v-if="key == parentKey" v-model="addListForm.value[key]" placeholder="请选择" style="width: 100%" >-->
<!--                        <el-option-->
<!--                                v-for="item in parentDicValue1"-->
<!--                                :key="item.id"-->
<!--                                :label="item.value"-->
<!--                                :value="item.id">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
                    <el-input  v-model="addListForm.value[key]" :maxlength="200" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="排序值" label-width="90px" prop="sort" class="dictionDevelop_star">
                    <el-input v-model="addListForm.sort" type="number"></el-input>
                </el-form-item>
                <el-form-item :label="addListForm.status?'有效':'无效'" label-width="90px">
                    <el-switch v-model="addListForm.status" active-color="#13ce66"></el-switch>
                </el-form-item>
                <!--                <el-button type="success" icon="el-icon-plus" size="mini" @click="addOptions(addListForm.value)" style="margin-left: 85%">添加字段名称</el-button>-->

            </el-form>
        </el-dialog>

        <!--编辑选项-->
        <el-dialog title="" :visible.sync="dialogFormVisible4">
            <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                <span style="color: #3998F7;font-size: 22px">编辑字典选项</span>
                <span>
                <el-button @click="submitForm4" type="primary" size="small">保 存</el-button>
                <el-button type="danger" @click="abolish2(dialogFormVisible4,updataListForm.value,len2)" size="small">取 消</el-button>
                </span>

            </div>
            <el-form :model="updataListForm" :rules="rules4" ref="ruleForm4" class="demo-ruleForm" style="margin-left:80px" hide-required-asterisk>
                <el-form-item label="键值" label-width="90px" prop="key" class="dictionDevelop_star">
                    <el-input v-model="updataListForm.key" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="上级键值" label-width="90px">
                    <el-select  v-model="updataListForm.parent_key" placeholder="请选择" :disabled="haveParent" style="width: 100%" >
                        <el-option
                                v-for="item in parentDicValue1"
                                :key="item.id"
                                :label="item.value"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="显示标题" label-width="90px" >
                    <el-input v-model="updataListForm.title" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item :label="judge(key,true)" label-width="90px" v-for="(item,key) in updataListForm.value"
                              :key="key" prop="item">
<!--                    <el-input  v-model="updataListForm.value[key]" :maxlength="200"></el-input>-->
<!--                    <el-select v-if="key == parentKey" v-model="updataListForm.value[key]" placeholder="请选择字段说明" style="width: 100%" >-->
<!--                        <el-option-->
<!--                                v-for="item in parentDicValue1"-->
<!--                                :key="item.id"-->
<!--                                :label="item.value"-->
<!--                                :value="item.id">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
                    <el-input  v-model="updataListForm.value[key]" :maxlength="200"></el-input>
                </el-form-item>
                <el-form-item label="排序值" label-width="90px" prop="sort" class="dictionDevelop_star">
                    <el-input v-model="updataListForm.sort" type="number"></el-input>
                </el-form-item>
                <el-form-item :label="updataListForm.status?'有效':'无效'" label-width="90px">
                    <el-switch v-model="updataListForm.status" active-color="#13ce66"></el-switch>
                </el-form-item>
            </el-form>
        </el-dialog>

    </el-row>
</template>

<script>
    import http from '../../../APIService/http'
    import { MessageBox, Message } from 'element-ui';
    let number=1
    export default {
        name: "Main",
        data() {
            return {
                haveParent:false,
                parentCategoryArray:[],
                parentCategoryKey:[],
                parentDicArray:[],
                parentDicValue1:[],
                disableInp:false,
                parentKey:'',
                openOff:true,
                addUserDis:true,
                listDate:{
                    dictionary_id:'',
                    tenant_id:''
                },
                MyData:'',
                define_id:'',
                len:0,
                len2:0,
                updataActive:'',
                stateNum:1,
                optionsNum:1,
                form:{
                    category:'',
                    name:'',
                    parent_category:'',
                    value1:'',
                    status:true
                },
                rules:{
                    name:[
                        {required: true, message: '请输入字典名称', trigger: 'blur'}
                    ],
                    category:[
                        {required: true, message: '请输入字典ID', trigger: 'blur'}
                    ],
                    value1:[
                        {required: true, message: '请输入字段说明', trigger: 'blur'}
                    ],
                },
                upForm:{
                    category:'',
                    name:'',
                    parent_category:'',
                    status:true
                },
                rules2:{
                    name:[
                        {required: true, message: '请输入名称', trigger: 'blur'}
                    ],
                    category:[
                        {required: true, message: '请输入类型', trigger: 'blur'}
                    ],
                    value1:[
                        {required: true, message: '请输入说明', trigger: 'blur'}
                    ],
                },
                valueArr:[],
                addListForm:{
                    key:'',
                    parent_key:'',
                    title:'',
                    value:{
                        value1:'',
                        value2:'',
                        value3:'',
                        value4:'',
                        value5:'',
                        value6:'',
                        value7:'',
                        value8:'',
                    },
                    sort:1,
                    status:true
                },
                rules3:{
                    key:[
                        {required: true, message: '请输入键值', trigger: 'blur'}
                    ],
                    value1:[
                        {required: true, message: '请输入说明', trigger: 'blur'}
                    ],
                    sort:[
                        {required: true, message: '请输入排序值', trigger: 'blur'}
                    ],
                },
                updataListForm:{
                    key:'',
                    parent_key:'',
                    title:'',
                    value:{
                        value1:'',
                        value2:'',
                        value3:'',
                        value4:'',
                        value5:'',
                        value6:'',
                        value7:'',
                        value8:'',
                    },
                    sort:1,
                    status:''
                },
                rules4:{
                    key:[
                        {required: true, message: '请输入键值', trigger: 'blur'}
                    ],
                    value1:[
                        {required: true, message: '请输入说明1', trigger: 'blur'}
                    ],
                    sort:[
                        {required: true, message: '请输入排序值', trigger: 'blur'}
                    ],
                },
                dialogFormVisible:false,
                dialogFormVisible2:false,
                dialogFormVisible3:false,
                dialogFormVisible4:false,
                folderId:null,
                folderName:null,
                num:{
                    sum:0,
                },
                myactive1:false,
                myactive2:false,
                schTitle1:"",
                treeKey:"",
                //表格数据
                tableData: [
                    /*{
                        date: '2016-05-02',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1518 弄'
                    }, {
                        date: '2016-05-04',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1517 弄'
                    }, {
                        date: '2016-05-01',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1519 弄'
                    }, {
                        date: '2016-05-03',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1516 弄'
                    }*/
                ],
                filterText: '',
                compileDic:{
                    category:'',
                    old_category:'',
                    tenant_id:'',
                    define_id:''
                },
                data: [/*{
          id: 1,
          label: '一级 1'

        }, {
          id: 2,
          label: '一级 2',
        }, {
          id: 3,
          label: '一级 3',
        }, {
          id: 4,
          label: '一级 4',
        } ,{
          id: 5,
          label: '一级 5',
        }*/],
                defaultProps: {
                    label: 'label'
                }
            }
        },
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            }
        },
        created () {

            this.getLibrary();
        },

        methods:{

            submitForm4(formName) {
                this.$refs['ruleForm4'].validate((valid) => {
                    if (valid) {
                        this.upDateDictionary()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },


            //编辑列表
            async upDateDictionary() {


                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data={}
                    let obj = {...JSON.parse(JSON.stringify(this.updataListForm)),...JSON.parse(JSON.stringify(this.updataListForm)).value};
                    delete obj.value
                    obj.status=obj.status?'ACTIVE':'INACTIVE'
                    data={...obj,...this.listDate}

                    await http.post('/wapi/v1/upDateDictionary', data).then(res => {

                        loading.close()
                        if (res.success){
                            this.abolish2(this.dialogFormVisible4,this.updataListForm.value,this.len2)
                            this.getDictionaryList(this.MyData)
                            Message({
                                type: 'success',
                                message: '保存成功'
                            });
                        }else {
                            Message.error('保存失败');

                        }
                    })

                } catch (err) {
                    loading.close()
                    console.log(`error:${err}`)
                }
            },
            submitForm3(formName) {

                this.$refs['ruleForm3'].validate((valid) => {
                    if (valid) {
                        this.addDictionary()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },

            //新增列表
            async addDictionary() {


                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {

                    let data={}
                    let obj = {...JSON.parse(JSON.stringify(this.addListForm)),...JSON.parse(JSON.stringify(this.addListForm)).value};
                    delete obj.value
                    obj.status=obj.status?'ACTIVE':'INACTIVE'
                    data={...obj,...this.compileDic}

                    await http.post('/wapi/v1/addDictionary', data).then(res => {

                      loading.close()
                        if (res.success){

                            this.abolish2(this.dialogFormVisible3,this.addListForm.value)
                            for(let key in this.addListForm){
                                if(key!=='value'){
                                this.addListForm[key]  = ''
                                }else {
                                    for (let k in this.addListForm[key]) {
                                        this.addListForm[key][k]=""
                                    }

                                }
                            }
                            this.getDictionaryList(this.MyData)
                            Message({
                                type: 'success',
                                message: '保存成功'
                            });
                        }else {
                            Message.error('保存失败');

                        }
                    })

                } catch (err) {
                    loading.close()
                    console.log(`error:${err}`)
                }
            },
            //获取列表
            async getDictionaryList(treeData) {

                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        category: treeData.category,
                        // category: 'INSPECTION_ITEM',
                        tenant_id:user.tenant_id,
                        tenantId:treeData.tenant_id
                    }
                    number=1
                    this.tableData=[]
                    await http.post('/wapi/v1/getDictionaryList', data).then(res => {

                        loading.close()
                        if (res.success){
                            /*this.$set(this.tableData,'values',[])
                            for (let key in res.data) {
                                if(key.indexOf('value')===-1){
                                    this.$set(this.tableData,key,res.data[key])
                                }else {
                                    this.tableData.values.push(res.data[key])
                                }
                            }*/
                            this.tableData=res.data

                            this.tableData.forEach(item=>{
                                if(item.status==='ACTIVE'){
                                    item.status='有效'
                                }else if(item.status!=='ACTIVE'){
                                    item.status='无效'
                                }
                            })

                            if(this.tableData.length>0){
                                this.disableInp = true
                            }else{
                                this.disableInp = false
                            }


                        }


                    })

                } catch (err) {
                    loading.close()
                    console.log(`error:${err}`)
                }
            },
            //获取目录
            async getLibrary() {

                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id:user.tenant_id
                    }
                    this.data = [{define_id:2000,label:'自定义',children:[]}]
                    await http.post('/wapi/v1/getDictionaryDefineList', data).then(res => {

                        loading.close();
                        // this.$nextTick(() => { this.$refs.tree.setCurrentKey(this.treeKey)})
                        setTimeout(() => { this.$refs.tree.setCurrentKey(this.treeKey)},100)
                        if (res.success){
                            for (let i=0;i<res.data.length;i++){
                                if (res.data[i].builtin === 'T' ){
                                    // this.data[0].children.push(res.data[i])
                                } else {
                                    this.data[0].children.push(res.data[i])
                                }
                            }
                            // this.data=res.data
                            console.log(this.data)

                        }
                    })

                } catch (err) {
                    loading.close();
                    console.log(`error:${err}`)
                }
            },
            submitForm(formName) {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.addDictionaryDefine()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //新增字典
            async addDictionaryDefine() {

                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {

                    let user = this.$store.getters.getUser
                    let data = JSON.parse(JSON.stringify(this.form));
                    data.tenant_id=user.tenant_id;
                    console.log(data.status)
                    data.status = data.status ? 'ACTIVE' : 'INACTIVE'
                    await http.post('/wapi/v1/addDictionaryDefine', data).then(res => {

                        loading.close()
                        if (res.success){
                            this.getLibrary()
                            Message({
                                type: 'success',
                                message: '保存成功'
                            });
                            this.abolish(this.dialogFormVisible,this.form)
                            for(let key in this.form){
                                this.form[key]  = ''
                            }
                            this.form.status = true
                            this.data[1].children.unshift({...(res.data[0]),...{label:res.data[0].name}})

                        }else {
                            Message.error('保存失败');

                        }
                    })

                } catch (err) {
                    loading.close()
                    console.log(`error:${err}`)
                }
            },

            submitForm2(formName) {
                this.$refs['ruleForm2'].validate((valid) => {
                    if (valid) {
                        this.upDateDictionaryDefine()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },

            //编辑字典
            async upDateDictionaryDefine() {


                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data = {...JSON.parse(JSON.stringify(this.upForm)),...(this.compileDic)};

                    data.status = data.status ? 'ACTIVE' : 'INACTIVE'
                    await http.post('/wapi/v1/upDateDictionaryDefine', data).then(res => {

                        loading.close()
                        if (res.success){
                            this.schTitle1=res.data[0].name
                            this.abolish(this.dialogFormVisible2,this.upForm,this.len)
                            // for(let key in this.upForm){
                            //     this.upForm[key]  = ''
                            // }
                            console.log(res.data,31)

                            this.valueArr=[]
                            for(let key in res.data[0]){
                                if(key.indexOf('value')!== -1){
                                    if(res.data[0][key]){
                                        this.$set(this.upForm,key,res.data[0][key])
                                        this.valueArr.push(res.data[0][key])
                                        this.len++
                                    }
                                }
                            }
                            this.getLibrary()
                            this.upForm = data
                            if (this.upForm.status==='ACTIVE'){
                                this.upForm.status = true
                            } else {
                                this.upForm.status = false
                            }
                            delete this.upForm.old_category
                            delete this.upForm.tenant_id
                            delete this.upForm.define_id
                            Message({
                                type: 'success',
                                message: '保存成功'
                            });
                            for(let i=0;i<this.data.length;i++){
                                if((this.data[1].children[i].define_id) === (res.data[0].define_id)){

                                    this.data[1].children[i]={...(res.data[0]),...{label:res.data[0].name}}

                                    break
                                }
                            }
                            console.log(this.data,32)

                        }else {
                            Message.error('保存失败');

                        }
                    })

                } catch (err) {
                    loading.close()
                    console.log(`error:${err}`)
                }
            },
            //新增字典保存按钮
            //树状列表
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },

            /*//新建顶级文件夹
            append2(value) {
                const newChild = { id: id++, label: value, children: [] };
                this.data2.push(newChild);
            },*/
            //新建字典弹框
            open3() {
                this.dialogFormVisible=true
                this.stateNum=1
                this.getParentCategory()
            },
            //编辑字典弹框
            open4() {
                if(this.updataActive){
                    this.stateNum=this.len
                    this.dialogFormVisible2=true

                }
            },
            //添加列表弹框
            addListOpen() {
                this.optionsNum=1
                this.dialogFormVisible3=true
                this.addListForm={
                    key:'',
                    sort:1,
                    value:{
                        value1:'',
                        value2:'',
                        value3:'',
                        value4:'',
                        value5:'',
                        value6:'',
                        value7:'',
                        value8:'',
                    },
                    status:true
                }
                this.addListForm.sort = this.tableData[this.tableData.length - 1].sort + 1
            },

            //编辑按钮
            myDetails(index, row){

                console.log(row)
                this.listDate.dictionary_id=row.dictionary_id
                this.listDate.tenant_id=row.tenant_id
                let obj={}
                obj.key=row.key
                if(row.parent_key){
                    obj.parent_key=row.parent_key
                }else{
                    obj.parent_key = ''
                }
                obj.title=row.title ? row.title :''
                obj.sort=row.sort
                obj.status=row.status==='有效'?true:false
                obj.value={}
                this.len2=0
                let a=0
                for(let val in row){
                    if(val.indexOf('value')!== -1){
                        if(this.onOff(val)<this.valueArr.length){
                            obj.value[val]=row[val]
                            this.len2++
                        }
                    }
                }
                this.optionsNum=this.len2
                this.updataListForm=JSON.parse(JSON.stringify(obj))
                console.log(this.updataListForm)

                this.dialogFormVisible4=true
            },
            //取消清空说明
            abolish(dialogFormVisible,form,len){
                let a=len?len:1
                if(dialogFormVisible==this.dialogFormVisible){
                    this.$refs['ruleForm'].resetFields();
                    this.dialogFormVisible = false;
                }else if(dialogFormVisible==this.dialogFormVisible2){
                    this.$refs['ruleForm2'].resetFields();
                    this.dialogFormVisible2 = false;
                }
                for(let i=this.stateNum;i>a;i--){
                    this.$delete(form,'value'+i)

                }
                for(let key in this.form){
                    this.form[key]  = ''
                }
                this.form.status = true
                this.stateNum=a
            },
            //取消清空字段名称
            abolish2(dialogFormVisible,form,len){
                let a=len?len:1
                if(dialogFormVisible==this.dialogFormVisible3){
                    this.$refs['ruleForm3'].resetFields();
                    this.dialogFormVisible3 = false;

                }else if(dialogFormVisible==this.dialogFormVisible4){
                    this.$refs['ruleForm4'].resetFields();
                    this.dialogFormVisible4 = false;
                }
                for(let i=this.optionsNum;i>a;i--){
                    this.$delete(form,'value'+i)

                }
                this.optionsNum=a
            },
            //添加说明
            addExplain(form){
                this.stateNum++
                if(this.stateNum<=8){
                    this.$set(form,'value'+this.stateNum,'')
                }
            },//添加选项字段
            addOptions(form){
                this.optionsNum++
                if(this.optionsNum<=8){
                    this.$set(form,'value'+this.optionsNum,'')
                }
            },
            //判断文本框类型
            judgeType(key){
                if(key==='name'){
                    return 'input'
                }else if(key==='category'){
                    return 'input'
                }
            },
            judgePlace(key){
                // if(this.disableInp){
                //     return ''
                // }
                if(key === 'parent_category'){
                    return '请选择关联的上级字典'
                }else if(key==='name'){
                    return '请输入字典名称'
                }else if(key==='category'){
                    return '请输入字典ID'
                }else{
                    return '请输入字段的名称'
                }
            },

           async getParentCategory(){
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id:user.tenant_id
                }
               await http.post('/wapi/v1/getParentCategory', data).then(res => {
                    if(res.success){
                        this.parentCategoryArray = res.data

                    }
                })
            },

            onOff(key){
                return  parseInt(key.replace('value',''))-1

            },
            //判断键名
            judge(key,onf){
                if(onf==true){
                    if(key==='value1'){
                        return this.valueArr[0]
                    }else if(key==='value2'){
                        return this.valueArr[1]
                    }else if(key==='value3'){
                        return this.valueArr[2]
                    }else if(key==='value4'){
                        return this.valueArr[3]
                    }else if(key==='value5'){
                        return this.valueArr[4]
                    }else if(key==='value6'){
                        return this.valueArr[5]
                    }else if(key==='value7'){
                        return this.valueArr[6]
                    }else if(key==='value8'){
                        return this.valueArr[7]
                    }else {
                        return key
                    }
                }else {
                    if(key==='name'){
                        return '字典名称'
                    }else if(key==='category'){
                        return '字典ID'
                    }else if(key==='parent_category'){
                        return '上级字典'
                    }else if(key==='value1'){
                        return '字段说明1'
                    }else if(key==='value2'){
                        return '字段说明2'
                    }else if(key==='value3'){
                        return '字段说明3'
                    }else if(key==='value4'){
                        return '字段说明4'
                    }else if(key==='value5'){
                        return '字段说明5'
                    }else if(key==='value6'){
                        return '字段说明6'
                    }else if(key==='value7'){
                        return '字段说明7'
                    }else if(key==='value8'){
                        return '字段说明8'
                    }else {
                        return key
                    }
                }

            },
            //点击行
            myRowClick(row){

                if (row){
                    // this.form.user_id=row.user_id
                    this.radio=parseInt(row.rowIndex)
                    this.myStatus=row.status==="ACTIVE"?'在职':'离职'

                    if(row.zhuGuan==='STAFF'){
                        this.myZhuGuan='否'
                        this.form.zhuGuan=false
                    }else if(row.zhuGuan==='MANAGER'){
                        this.myZhuGuan='是'
                        this.form.zhuGuan=true
                    }
                    this.tabActive=true
                    this.tableDataRow=row
                }

            },


            handleNodeClick(data,node,ele) {
                console.log(data)
                if(data.parent_category){
                    this.getParentDicValue(data.parent_category)
                    this.haveParent = false
                }else{
                    this.haveParent = true
                    this.parentCategoryKey = []
                    this.parentDicValue1 = []
                }

                this.getParentDicArray(data.category)

                this.openOff=false
                if (data.label === '系统内置' || data.label === '自定义') {
                    this.addUserDis = true
                    return;
                }else {

                    this.treeKey = node.key
                    this.define_id = data.define_id
                    this.MyData = data

                    this.getDictionaryList(data)


                    this.myactive2 = false
                    this.myactive1 = true
                    this.schTitle1 = data.label
                    //禁用状态
                    this.updataActive = true
                    //编辑字典
                    this.compileDic.define_id = data.define_id
                    this.compileDic.old_category = data.category
                    this.compileDic.tenant_id = data.tenant_id
                    this.compileDic.category = data.category
                    this.upForm.category = data.category
                    this.upForm.name = data.name
                    this.upForm.parent_category = data.parent_category

                    if (data.status === 'ACTIVE'){
                        this.upForm.status = true
                    } else {
                        this.upForm.status = false
                    }

                    for (let key in this.upForm) {
                        if (key.indexOf('value') !== -1) {
                            this.$delete(this.upForm, key)
                        }
                    }
                    this.len = 0
                    this.valueArr = []
                    for (let key in data) {
                        if (key.indexOf('value') !== -1) {
                            if (data[key]) {
                                this.$set(this.upForm, key, data[key])
                                this.valueArr.push(data[key])
                                this.len++
                            }
                        }
                    }
                    //禁用状态
                    if (data.onlyread === 'T') {
                        this.updataActive = false
                    } else {
                        this.updataActive = true
                    }

                }
            },

            async getParentDicArray(category){
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id:user.tenant_id,
                    category:category
                }
                await http.post('/wapi/v1/getParentDicArray', data).then(res => {
                    if(res.success){
                        this.parentDicArray = res.data

                    }
                })
            },
            async getParentDicValue(category){
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id:user.tenant_id,
                    category:category
                }
                await http.post('/wapi/v1/getParentDicValue', data).then(res => {
                    if(res.success){
                        this.parentDicValue1 = []
                        for(let i = 0; i<res.data.length;i++){
                            if(res.data[i].key){
                                this.parentDicValue1.push({
                                    id:res.data[i].key,
                                    value:res.data[i].key
                                })
                            }
                        }

                    }
                })
            }

        },
        updated() {
            console.log(this.form)
        }

    };
</script>

<style>
    /*限制文字长度*/
    #dictionDevelop .el-tree-node__content span{
        max-width: 240px;

        overflow: hidden;
        margin-left: 10px;
        color: #bbbbbb;
        text-overflow: ellipsis;
        font-size: 12px;
        white-space: nowrap;
    }
    #dictionDevelop .el-tree-node__expand-icon{
        display: none;
    }
    #dictionDevelop .el-tree-node__content{
        /*display: flex;*/
        /*justify-content: space-between;*/
        height: 40px;
    }
    #dictionDevelop .el-tree-node.is-expanded.is-focusable > .el-tree-node__content{
        /*background: #f6f7fa;*/
    }
    #dictionDevelop .filter-tree .el-tree-node__children > .el-tree-node > .el-tree-node__content:before{
        content: "";
        display: inline-block;
        background: url("../../../assets/images/diction.png") no-repeat;
        background-size:16px ;
        width: 16px;
        height: 16px;
        margin: 20px;
    }
    #dictionDevelop .filter-tree .el-tree-node__children > .el-tree-node > .el-tree-node__content span{
        margin-left: 0;
        font-size: 16px;
        max-width: 240px;
        color: #606266;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    /*输入框背景*/
    #dictionDevelop .sWei .el-input__inner{
        background: #eee;
    }
    #dictionDevelop .StoCen{
        background: white;
        height: auto;
        padding: 0 15px;
    }
    /*.el-main{
      padding: 0;
    }*/
    #dictionDevelop{
        display: flex;
        justify-content: center;
        height: auto;
    }
    #dictionDevelop .StoW .el-form-item__label{
        font-size:14px;
        color: black;
        font-weight: bold;
    }
    #dictionDevelop .el-row {
        margin-bottom: 12px;
        height: 30px;
    }
    #dictionDevelop .xux {
        border-bottom: 2px dashed #eee;
        height: 10px;
    }
    #dictionDevelop .butC {
        padding: 8px 10px;
        margin-top: 26px;
    }
    #dictionDevelop .tally {
        border: 2px solid rgb(29, 170, 252);
        height: 100%;
        width: 110px;
        margin: 0 10px;
        padding: 0 5px;
        color: rgb(29, 170, 252);
    }
    #dictionDevelop .tally:nth-of-type(2) {
        border-color: rgb(30, 255, 79);
        color: rgb(30, 255, 79);
    }
    #dictionDevelop .tally:nth-of-type(3) {
        border-color: rgb(255, 203, 30);
        color: rgb(255, 203, 30);
    }
    #dictionDevelop .tally:nth-of-type(4) {
        border-color: rgb(255, 30, 244);
        color: rgb(255, 30, 244);
    }
    #dictionDevelop .tallyBox {
        height: 60px;
        display: flex;
        margin-bottom: 10px;
        justify-content: flex-end;
    }
    #dictionDevelop .tally .el-row {
        margin: 0;
        font-size: 12px;
        height: 25px;
    }
    #dictionDevelop .tally .el-row:nth-of-type(2) {
        text-align: center;
        font-size: 20px;
    }
    #dictionDevelop .cell{
        text-align: left;
    }
    #dictionDevelop .el-dialog__header {
        border-bottom: 2px dashed #DCDFE6;
        padding: 20px 0 20px 0;
        margin: 20px 20px 10px;
    }
    #dictionDevelop .el-dialog__close{
        display: none;
    }
    #dictionDevelop .el-dialog__body{
        padding-right:100px ;
    }
    #dictionDevelop .el-form-item__label{
        color: black;
        text-align: left;
    }
    #dictionDevelop .dictionDevelop_table_cell {
        color: #2b92fa !important;
    }
    #dictionDevelop .dictionDevelop_star label:after{
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
    .dialog-footer {
        margin-top: 10px;
    }
    #el-button span{
        font-weight: bold;
    }
    #search .el-input__inner::-webkit-input-placeholder {
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// src/pages/develop/components/diction.vue